import PageIndex from './PageIndex';
import PageCreate from './PageCreate';
import PageSettings from './PageSettings';
import PageSingle from './PageSingle';

export default function (app) {

    const settings = PageSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    PageIndex(app, settings);

    PageCreate(app, settings);

    PageSingle(app, settings);

}